import type { DashboardInterpretation } from "../../types/api";

const MAX_HINT_LEN = 36;

/** One short line for warning/critical only; hidden when status is ok. */
export function shortInsight(interpretation: DashboardInterpretation): string | null {
  if (interpretation.status === "ok") return null;

  const raw =
    interpretation.action_hint?.trim() ||
    interpretation.watch_signal?.trim() ||
    interpretation.good_signal?.trim() ||
    "";

  if (!raw) return null;
  if (raw.length <= MAX_HINT_LEN) return raw;
  return `${raw.slice(0, MAX_HINT_LEN - 1)}…`;
}
